import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { recordDraftSaved } from '@states/drafts/draftSavedAt';

import type { PrimitiveAtom, SetStateAction } from 'jotai';

export const NOTE_DRAFT_ATOM_KEY = 'noteDraft';

const noteDraftStorageAtom = atomWithStorage(NOTE_DRAFT_ATOM_KEY, '', undefined, {
  getOnInit: true,
});

export const noteDraftAtom: PrimitiveAtom<string> = atom(
  (get) => get(noteDraftStorageAtom),
  (_get, set, update: SetStateAction<string>) => {
    set(noteDraftStorageAtom, update);
    recordDraftSaved(NOTE_DRAFT_ATOM_KEY);
  },
);
